import * as React from 'react';
import { createPersistedState } from '../hooks/use-persisted-state';

const useVisitorContextState = createPersistedState('visitorType');

export type VisitorType = 'local' | 'foreigner';

export type VisitorContextType = readonly [
  VisitorType,
  (newType: VisitorType) => void
];

export const VisitorContext = React.createContext<VisitorContextType>([
  'local',
  function noop() {},
]);

export const VisitorProvider: React.FC = ({ children }) => {
  const value = useVisitorContextState<VisitorType>('local');

  return (
    <VisitorContext.Provider value={value}>{children}</VisitorContext.Provider>
  );
};
